import React from 'react'
import { Link } from 'react-router'

import {  Col, Button } from 'reactstrap';


export default class ProfileButton extends React.Component {

	
	renderProvider(){
		return (
			<Link to="/prestataire/fiche/update" >
				<Button className="btn-green">Modifier mon dossier</Button>
			</Link>
		)
	}

	renderManager(){
		const { provider } = this.props
		
		return (
			<div>
	            <Link to={"/manager/prestataire/"+provider.id+"/update"} ><Button className="btn-transparent">Modifier la fiche</Button></Link> {' '}{' '}
	            <Link to={"/manager/prestataire/"+provider.id+"/status"} > <Button className="btn-green">Changer le statut</Button> </Link>
	         </div>
		)
	}

	render(){
		const { user } = this.props

		if(this.props.responsive){
			return(
				<Col xs="12" sm="6">

					<div className="resp-left resp-left-title">
						{user.role == "provider" &&
							"Ma fiche"
						||
							"Lead"
						}
					</div>

					<div className="resp-right">
						{user.role == "provider" &&
							this.renderProvider()
						||
							this.renderManager()
						}
					</div>
				</Col>
			)

		}else{
			return(
				<Col className="text-right" xs="12" sm="6">
					{user.role == "provider" &&
						this.renderProvider()
					||
						this.renderManager()
					}
				</Col>
			)
		}
	}
}


// WEBPACK FOOTER //
// ./src/provider/components/profile/ProfileButton.js